















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CommentItem from './commentItem.vue';
import CommentEdit from './commentEdit.vue';
import { sortCommentList } from './commentOperation';

type ICreateOrUpdateComment = IComment.IRequest.ICreateOrUpdateComment;
type ICommentInfo = IComment.IResponse.ICommentInfo;

@Component({
  components: {
    CommentItem,
    CommentEdit,
  },
})
export default class CommentList extends Vue {
  @Prop({default: () => [], required: true}) private commentList!: ICommentInfo[];
  @Prop({default: ''}) private url!: string;
  private defaultPageSize: number = 5;
  private currentList: ICommentInfo[] = [];
  private currentPage = 1;
  private commentListBySort: ICommentInfo[] = [];
  private changePage(page: number, pageSize: number) {
    this.currentPage = page;
    const start = (page - 1) * pageSize;
    const end = start + pageSize;
    this.currentList = this.commentListBySort.slice(start, end);
  }
  @Watch('commentList', {immediate: true})
  private WacthCommentList(newVal: ICommentInfo[]) {
    this.commentListBySort = sortCommentList(this.commentList);
    this.changePage(this.currentPage, this.defaultPageSize);
  }
  private deleteComment(commentId: string) {
    const findedIndex = this.commentList.findIndex((comment: ICommentInfo) => {
      return comment.id === commentId;
    });
    this.commentList.splice(findedIndex, 1);
  }
  private handleCreatedComment(comment: ICreateOrUpdateComment) {
    this.$emit('created', comment);
  }
}
